import { Injectable } from "@angular/core";
import { Subject } from "rxjs";

@Injectable()
export class SchedulerAsideService {
  private _isCollapsed = false;

  public onCollapsed = new Subject<boolean>();

  setCollapse(value) {
    this._isCollapsed = value;
    this.onCollapsed.next(value);
  }

  isCollapsed() {
    return this._isCollapsed;
  }
}
